import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { useHeaderBorderStyles } from "@circle-react-shared/uikit/HeaderV3/useHeaderColors";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useBackendProps } from "@circle-react/providers/AppContext";
import { Link } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { SearchWrapper } from "@/react/components/HeaderV2/Search";
import { useMobileDrawer } from "@/react/components/Layout/MobileDrawer/mobileDrawerContext";
import {
  anchorClassNames,
  legacyClassNames,
} from "@/react/helpers/cssAnchorHelpers";
import { useRouteHelpers } from "@/react/routes/Main/useRouteHelpers";

import { CommunityBrand } from "./CommunityBrand";
import { RightActionContent } from "./RightActionContent";

export const MobileAppBar = () => {
  const { minimal_layout: isMinimalLayout } = useBackendProps();
  const mobileDrawer = useMobileDrawer();

  const { currentCommunity, currentCommunitySettings } = usePunditUserContext();

  const styles = useHeaderBorderStyles();

  const isPostDetailsPage = Boolean(useRouteHelpers().isPostDetailPage);

  const isNewPostDetailsHeaderOnMobileWebEnabled = Boolean(
    currentCommunitySettings?.post_details_mobile_header_enabled,
  );

  const handleToggleMobileDrawer = () => {
    mobileDrawer?.toggle();
  };

  if (isPostDetailsPage && isNewPostDetailsHeaderOnMobileWebEnabled) {
    return null;
  }

  return (
    <div className="sticky top-0 z-30">
      <header
        id="mainHeader"
        className={classNames(
          anchorClassNames("header header-v2"),
          "!bg-c-header",
        )}
        style={styles}
      >
        <div className={anchorClassNames("header__inside")}>
          {!isMinimalLayout && (
            <div className={anchorClassNames("header__menu")}>
              <IconButton
                name="hamburger"
                onPointerDown={event => event.stopPropagation()}
                onClick={handleToggleMobileDrawer}
                ariaLabel={t("toggle_menu")}
                className={legacyClassNames("toggle-button")}
                buttonSize={28}
                iconSize={20}
                iconClassName="!w-5 !h-5 !text-c-header"
              />
            </div>
          )}
          <div
            className={classNames(anchorClassNames("header__left"), {
              "!justify-start": isMinimalLayout,
            })}
          >
            <CommunityBrand currentCommunity={currentCommunity} />
          </div>
          <div className={anchorClassNames("header__actions")}>
            <SearchWrapper />

            <div className={anchorClassNames("header__action")}>
              <a href="/analytics">
                <svg
                  className={classNames(
                    anchorClassNames("icon"),
                    legacyClassNames("icon-analytics"),
                  )}
                  viewBox="0 0 24 24"
                >
                  <use xlinkHref="#icon-analytics" />
                </svg>
              </a>
            </div>

            <div className={anchorClassNames("header__action")}>
              <Link to="/settings/audience/manage">
                <svg
                  className={classNames(
                    anchorClassNames("icon"),
                    legacyClassNames("icon-members"),
                  )}
                  viewBox="0 0 24 24"
                >
                  <use xlinkHref="#icon-members" />
                </svg>
              </Link>
            </div>
            <div className={anchorClassNames("header__action")}>
              <Link to="/settings">
                <svg
                  className={classNames(
                    anchorClassNames("icon"),
                    legacyClassNames("icon-settings"),
                  )}
                  viewBox="0 0 24 24"
                >
                  <use xlinkHref="#icon-settings" />
                </svg>
              </Link>
            </div>
            <div
              className={classNames(
                anchorClassNames("header__user"),
                "relative z-30",
              )}
            >
              <RightActionContent />
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};
